// @ts-nocheck
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui";
import { cn } from "@/lib/utils";
import { StockBadge } from "./StockBadge";
import { fmtDate } from "./sellerDetail.utils";

export const InventoryTab = ({ d }) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-base">Inventory</CardTitle>
    </CardHeader>
    <CardContent className="p-0">
      <table data-testid="inventory-table" className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 dark:border-slate-700">
            {[
              "SKU",
              "Product",
              "Stock",
              "Threshold",
              "Status",
              "Last Sync",
            ].map((h, i) => (
              <th
                key={i}
                className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
          {d.inventory.map((item) => (
            <tr
              key={item.sku}
              data-testid={`inv-row-${item.sku}`}
              className="hover:bg-slate-50 dark:hover:bg-slate-800/50"
            >
              <td className="px-4 py-2.5 font-mono text-xs text-indigo-600 dark:text-indigo-400">
                {item.sku}
              </td>
              <td className="px-4 py-2.5 text-slate-900 dark:text-slate-100">
                {item.name}
              </td>
              <td className="px-4 py-2.5">
                <span
                  className={cn(
                    "font-medium",
                    item.stock === 0
                      ? "text-rose-600 dark:text-rose-400"
                      : item.stock <= item.lowThreshold
                        ? "text-amber-600 dark:text-amber-400"
                        : "text-slate-900 dark:text-slate-100",
                  )}
                >
                  {item.stock}
                </span>
              </td>
              <td className="px-4 py-2.5 text-slate-500 dark:text-slate-400">
                {item.lowThreshold}
              </td>
              <td className="px-4 py-2.5">
                <StockBadge status={item.status} />
              </td>
              <td className="px-4 py-2.5 text-xs text-slate-500 dark:text-slate-400">
                {fmtDate(item.lastSync)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </CardContent>
  </Card>
);
